// 사이트 설정 파일
export const siteConfig = {
  // 기본 사이트 이름 (환경 변수 지원)
  siteName: process.env.REACT_APP_SITE_NAME || "MyECRF",

  // 사이트 설명 (환경 변수 지원)
  siteDescription:
    process.env.REACT_APP_SITE_DESCRIPTION || "커스터마이징 전문 eCRF 플랫폼",

  // 사이트 로고 텍스트 (환경 변수 지원)
  logoText: process.env.REACT_APP_LOGO_TEXT || "EDC Platform",

  // 다국어 지원 사이트 이름 (환경 변수 지원)
  multiLanguageNames: {
    ko: process.env.REACT_APP_SITE_NAME_KO || "MyECRF",
    en: process.env.REACT_APP_SITE_NAME_EN || "MyECRF",
    ja: process.env.REACT_APP_SITE_NAME_JA || "MyECRF",
    "zh-CN": process.env.REACT_APP_SITE_NAME_ZH_CN || "MyECRF",
    "zh-TW": process.env.REACT_APP_SITE_NAME_ZH_TW || "MyECRF",
    it: process.env.REACT_APP_SITE_NAME_IT || "MyECRF",
    fr: process.env.REACT_APP_SITE_NAME_FR || "MyECRF",
    de: process.env.REACT_APP_SITE_NAME_DE || "MyECRF",
    es: process.env.REACT_APP_SITE_NAME_ES || "MyECRF",
    ru: process.env.REACT_APP_SITE_NAME_RU || "MyECRF",
    pt: process.env.REACT_APP_SITE_NAME_PT || "MyECRF",
    ar: process.env.REACT_APP_SITE_NAME_AR || "MyECRF",
    hi: process.env.REACT_APP_SITE_NAME_HI || "MyECRF",
  },

  // 프로젝트별 제목 포맷
  projectTitleFormat: "{siteName} - {projectName}",

  // 페이지별 제목 포맷
  pageTitleFormats: {
    login: "{siteName} - 로그인",
    dashboard: "{siteName} - 대시보드",
    ecrf: "{siteName} - {projectName}",
    formBuilder: "{siteName} - 폼 빌더",
    help: "{siteName} - 도움말",
    default: "{siteName}",
  },
};

// 현재 언어에 따른 사이트 이름 가져오기
export const getSiteName = (language = "ko") => {
  return siteConfig.multiLanguageNames[language] || siteConfig.siteName;
};

// 페이지별 제목 생성
export const getPageTitle = (page, options = {}) => {
  const { language = "ko", projectName = "", customTitle = "" } = options;
  const siteName = getSiteName(language);

  if (customTitle) {
    return `${siteName} - ${customTitle}`;
  }

  const format =
    siteConfig.pageTitleFormats[page] || siteConfig.pageTitleFormats.default;

  return format
    .replace("{siteName}", siteName)
    .replace("{projectName}", projectName);
};
